import type { ParallaxOffsetTypeSettings } from '#types/components/cms/collection'
import type { InjectionKey } from 'vue'

export const ParallaxLayerKey: InjectionKey<Ref<ParallaxOffsetTypeSettings | undefined>>
  = Symbol('ParallaxLayerKey')
